"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_intersection_observer_1 = require("react-intersection-observer");
const functions_1 = require("@/common/functions");
const CircularProgress_1 = __importDefault(require("@mui/material/CircularProgress"));
/**
 * @desc vertical scroll only
 * @param needDelay - inView가 두 번 트리거 되는 경우 사용 (예: 무한스크롤 + Masonry Grid)
 */
function default_1({ fetchNextPage, isFetchingNextPage, hasRenderData, additionalCss = { height: '30px' }, needDelay, }) {
    const [hideTarget, setHideTarget] = (0, react_1.useState)(needDelay);
    const revealTargetAfterDelay = () => (0, functions_1.delay)(500).then(() => setHideTarget(false));
    (0, react_1.useEffect)(() => {
        if (needDelay) {
            revealTargetAfterDelay();
        }
    }, [needDelay]);
    const { ref, inView } = (0, react_intersection_observer_1.useInView)();
    (0, react_1.useEffect)(() => {
        if (inView) {
            if (needDelay) {
                setHideTarget(true);
                revealTargetAfterDelay();
            }
            fetchNextPage();
        }
    }, [inView]);
    if (!hasRenderData)
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ css: Object.assign({ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center', pointerEvents: 'none' }, additionalCss) }, { children: isFetchingNextPage ? ((0, jsx_runtime_1.jsx)(CircularProgress_1.default, { size: 24, color: "secondary", thickness: 4 })) : (!hideTarget && (0, jsx_runtime_1.jsx)("div", { ref: ref, css: { position: 'absolute', inset: 0 } })) })));
}
exports.default = default_1;
